// The address waiting for its verification code. Kept in sessionStorage, never in
// the page URL: analytics and session-replay tools record full URLs.
export const VERIFICATION_EMAIL_KEY = 'talktime.verification.email';

interface EmailStorage {
   getItem(key: string): string | null;
   setItem(key: string, value: string): void;
   removeItem(key: string): void;
}

const browserStorage = (): EmailStorage | null => {
   try {
      return typeof sessionStorage === 'undefined' ? null : sessionStorage;
   } catch {
      return null;
   }
};

export function rememberVerificationEmail(email: string, storage = browserStorage()) {
   try {
      storage?.setItem(VERIFICATION_EMAIL_KEY, email);
   } catch { /* storage or analytics unavailable */ }
}

export function verificationEmail(storage = browserStorage()): string {
   try {
      return storage?.getItem(VERIFICATION_EMAIL_KEY) || '';
   } catch {
      return '';
   }
}

export function forgetVerificationEmail(storage = browserStorage()) {
   try {
      storage?.removeItem(VERIFICATION_EMAIL_KEY);
   } catch { /* storage or analytics unavailable */ }
}
